<template>
  <div v-show="visible" class="inner-loading">
    <v-container fill-height>
      <v-layout row justify-center align-center>
        <v-progress-circular :size="70" :width="7" indeterminate color="primary" />
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style>
.inner-loading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
}
.application.theme--light .inner-loading {
  background: hsla(0, 0%, 90%, 0.6);
}
.application.theme--dark .inner-loading {
  background: hsla(0, 0%, 40%, 0.6);
}
</style>
